import {
    SET_NOTIFICATIONS,
    SET_NOTIFICATIONS_ERROR,
    SET_NOTIFICATIONS_LAST_READ_AT,
    LOAD_MORE_NOTIFICATIONS_START,
    LOAD_MORE_NOTIFICATIONS_SUCCESS,
    LOAD_MORE_NOTIFICATIONS_FAILURE,
    CLEAR_NOTIFICATIONS_BADGE,
    UPDATE_USER_NOTIFICATIONS_READ_AT,
    MARK_NOTIFICATIONS_READ_REQUEST,
    MARK_NOTIFICATIONS_READ_SUCCESS
} from 'store/actions/types';

export const setNotifications = data => {
    return {
        type: SET_NOTIFICATIONS,
        payload: data
    };
};

export const setNotifcationsError = data => ({
    type: SET_NOTIFICATIONS_ERROR,
    payload: data
});

export const setNotificationsLastReadAt = data => ({
    type: SET_NOTIFICATIONS_LAST_READ_AT,
    payload: data
});

export const loadMoreNotifcationsStart = data => {
    return {
        type: LOAD_MORE_NOTIFICATIONS_START,
        payload: data
    };
};

export const loadMoreNotifcationsSuccess = data => ({
    type: LOAD_MORE_NOTIFICATIONS_SUCCESS,
    payload: data
});

export const loadMoreNotifcationsFailure = data => ({
    type: LOAD_MORE_NOTIFICATIONS_FAILURE,
    payload: data
});

export const clearNotificationsBadge = () => ({
    type: CLEAR_NOTIFICATIONS_BADGE
});

export const updateUserNotificationsReadAt = data => ({
    type: UPDATE_USER_NOTIFICATIONS_READ_AT,
    payload: data
});

export const markNotificationsReadRequest = () => ({
    type: MARK_NOTIFICATIONS_READ_REQUEST
});

export const markNotificationsReadSuccess = () => ({
    type: MARK_NOTIFICATIONS_READ_SUCCESS
});
